import { removeFalsyValues } from '@shopify/polaris-viz-core';

function getYAxisOptionsWithDefaults(yAxisOptions = {}) {
  const yAxisOptionsFiltered = removeFalsyValues(yAxisOptions);
  return {
    labelFormatter: value => `${value}`,
    integersOnly: false,
    fixedWidth: false,
    ...yAxisOptionsFiltered
  };
}
function getXAxisOptionsWithDefaults(xAxisOptions = {}) {
  const xAxisOptionsFiltered = removeFalsyValues(xAxisOptions);
  return {
    labelFormatter: value => `${value}`,
    hide: false,
    allowLineWrap: true,
    ...xAxisOptionsFiltered
  };
}

export { getXAxisOptionsWithDefaults, getYAxisOptionsWithDefaults };
